import PropTypes from 'prop-types';
import { ListContext, sortTypes, Table } from 'cat-ecommerce-alloy';
import { useSelector } from 'react-redux';
import { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { isEmpty, replaceTokensInString } from '@app/utils';
import { getCustomRenderers, getTableSchema } from './utils';
import styles from './TableStructure.module.scss';

const TableStructure = ({ close, listsLength }) => {
  const { t } = useTranslation();
  const updatedFieldSortFlag = useSelector(s => s.account.updatedFieldSortFlag);
  const isLoading = useSelector(s => s.account.isLoading);
  const {
    setCurrentPage,
    getList,
    getItemsPerPage,
    setItemsPerPage,
    getSortBy,
    getSortDirection,
    sortList
  } = useContext(ListContext);
  const lists = getList();
  const currentItemsPerPage = getItemsPerPage();
  if (listsLength !== currentItemsPerPage) {
    setItemsPerPage(listsLength);
  }

  const thereAreResults = !isEmpty(lists);
  const savedListsSchema = getTableSchema(t);
  const getTableItems = () =>
    lists.map(({ updated, orderId, ...rest }) => {
      const getReactKey = () => `${orderId}${updated}`;
      return {
        orderId,
        updated,
        reactKey: getReactKey(),
        close: close,
        ...rest
      };
    });

  const emptyListMessage = () => {
    return replaceTokensInString(
      t('NO_SAVED_LISTS_CREATED'),
      t('REQUISITIONLIST_ADD_NEW'),
      t('REQUISITIONLIST_ADD_NEW_UPLOAD')
    );
  };

  useEffect(() => {
    if (updatedFieldSortFlag) {
      if (
        getSortBy() !== 'updated' ||
        (getSortBy() === 'updated' && getSortDirection() === 1)
      ) {
        sortList('updated', sortTypes.DATE, -1);
      }
      setCurrentPage(1);
    }
  }, [updatedFieldSortFlag]);

  return (
    <div className={`${styles['saved-list__table-structure']} pb-4`}>
      <Table
        schema={savedListsSchema}
        data={getTableItems()}
        customRenderers={getCustomRenderers()}
      />
      {!isLoading && !thereAreResults && (
        <>
          <div
            className={`d-flex flex-column py-3 w-100 ${styles['no_results__message']}`}
          >
            {emptyListMessage()}
          </div>
        </>
      )}
    </div>
  );
};

export default TableStructure;

TableStructure.propTypes = {
  close: PropTypes.func,
  listsLength: PropTypes.number
};
